export default __webpack_public_path__ + "static/media/trac_payment_modal.7198b243.png";